import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-machine-database',
  templateUrl: './machine-database.component.html',
  styleUrls: ['./machine-database.component.scss']
})
export class MachineDatabaseComponent implements OnInit {

  @Input() identifiant !: any;

  constructor() { }

  ngOnInit(): void {
  }

}
